'use client';
import React from 'react';
import RenderFormFields from 'src/components/era-package/forms/RenderFormFields';

const DutyCalculationOption = ({ formData, setFormData }) => {
    const fields = [
	{
      name: 'totalFreightCharges',
      label: 'Total Freight Charges',
      type: 'number',
      maxLength: undefined,
      placeholder: '',
      defaultValue: '',
      sizeProp: { xs: 10 },
      required: true,
      disabled: false,
    },   
    {
      name: 'totalFreightChargesSplitOption',
      label: 'Total Freight Charges Split Option',
      type: 'auto value', 
      placeholder: 'Select Total Freight Charges Split Option',
      defaultValue: 'Split by weight',
      sizeProp: { xs: 12 },
      required: true,
      disabled: false,
    },   
    {
      name: 'mpfCalculation',
      label: 'MPF Calculation',
      type: 'toggle',
      maxLength: undefined,
      placeholder: '',
      defaultValue: false,
      sizeProp: { xs: 12 },
      required: true,
      disabled: false,
      icon: undefined,
    },
    {
      name: 'hmfCalculation',
      label: 'HMF Calculation',
      type: 'toggle',
      maxLength: undefined,
      placeholder: '',
      defaultValue: false,
      sizeProp: { xs: 12 },
      required: true,
      disabled: false,
      icon: undefined,
    },
  ];

  
    const optionsMap = {
        dutyCalculation: [
        { value: 'By Template', description: '' },
        { value: 'By Customs Tariff', description: '' },
        ],
        totalFreightChargesSplitOption: [
        { value: 'Split by weight', description: '' },
        { value: 'Split by value', description: '' },
        ],
  };

  return (
    <RenderFormFields
      fields={fields}
      formData={formData || {}}
      setFormData={setFormData}
      optionsMap={optionsMap} 
    />
  );
};

export default DutyCalculationOption;
